import {ChangeDetectionStrategy, Component, Input, OnDestroy, OnInit,} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {FormlyFieldConfig, FormlyFormOptions} from '@ngx-formly/core';
import {BaseComponent, IdAndHeader, ListFilterService} from 'compob2b-libs';
import {takeUntil, tap} from 'rxjs/operators';
import {NbButtonModule, NbCheckboxModule, NbIconModule, NbTooltipModule} from "@nebular/theme";
import {FormsModule} from "@angular/forms";
import {AsyncPipe, NgForOf, NgIf} from "@angular/common";

@Component({
  'standalone': true,
  selector: 'app-filter-panel',
  templateUrl: './filter-panel.html',
  styleUrls: ['./filter-panel.scss'],
  imports: [NbIconModule, NbTooltipModule, NbCheckboxModule, FormsModule, NbButtonModule, NgIf, AsyncPipe, NgForOf],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FilterPanel extends BaseComponent implements OnInit, OnDestroy {
  @Input() showHasStock = false;
  @Input() filter: ListFilterService;
  @Input() catalog: IdAndHeader;

  options: FormlyFormOptions = {};
  keyword = '';
  hasStock = false;

  constructor(protected readonly route: ActivatedRoute) {
    super();
  }

  ngOnInit() {
    this.route.queryParams.pipe(tap(params => {
      this.hasStock = params.hasStock === 'true';

      if (params.keyword !== undefined && params.keyword !== null && params.keyword !== '') {
        this.keyword = params.keyword;
      }
      else {
        this.keyword = '';
      }

      this.cdr.detectChanges();
    }), takeUntil(this.unsubscribe),).subscribe();
  }

  delete(key, value = null) {
    const removeParams = {};

    let dateFromKey = null;
    let dateToKey = null;
    this.filter.fieldsFeatures.forEach(oneFeature => {
      if (oneFeature.key === key) {
        if (oneFeature.type === 'date-range-picker') {
          dateFromKey = key + '_from';
          dateToKey = key + '_to';
        }
      }
    });

    if (dateFromKey && dateToKey) {
      removeParams[dateFromKey] = null;
      removeParams[dateToKey] = null;

    }
    else if (value) {
      let newValueOfMulti = null;
      for (const [valueKey, valueItem] of Object.entries(this.route.snapshot.queryParamMap['params'])) {
        if (valueKey.toString() === key.toString()) {
          const newValue = valueItem.toString()
            .split(',')
            .filter(i => {
              let v = value.value || value;
              if (value.value === null) {
                v = "null";
              }

              return i.toString() !== v.toString()
            });

          if (newValue.length > 0) {
            newValueOfMulti = newValue.join(',');
          }
        }
      }
      removeParams[key] = newValueOfMulti;

    }
    else if (key === 'classId') {
      const filterExist = this.filter.fieldsFeatures
        .filter(o => {
          return (/^-?[\d.]+(?:e-?\d+)?$/.test(o.key.toString()) === false && o.key.toString() !== 'classId');
        })
        .map(props => {
          return props.key;
        })

      filterExist.push('region');

      for (const [k] of Object.entries(this.route.snapshot.queryParamMap['params'])) {
        if (!filterExist.includes(k)) {
          removeParams[k] = null;
        }
      }
    }
    else {
      removeParams[key] = null;
    }

    this.navigate(removeParams);
    this.cdr.detectChanges();
  }

  reset(): void {
    this.filter.reset();
    this.cdr.detectChanges();
    this.router.navigate(['.'], {relativeTo: this.route});
  }

  onChangeRange(value) {
    this.navigate({hasStock: value || null});
  }

  getDisplayValue(item: FormlyFieldConfig, itemMulti = null): string {
    let value = '';

    if (item.templateOptions.getDisplayValue) {
      value = item.templateOptions.getDisplayValue(item, itemMulti);
    }
    else {

      value = item.templateOptions.label;
      if (item.defaultValue.label) {
        value += `: ${item.defaultValue.label}`;

      }
      else if (itemMulti.label) {
        value += `: ${itemMulti.label}`;

      }
      else if (itemMulti) {
        item.templateOptions?.options?.forEach(option => {
          if (option?.value == itemMulti) {
            value += `: ${option.label}`;
          }
        })
      }
    }

    return value;
  }

  private navigate(queryParams) {
    this.router.navigate(['.'], {
      relativeTo: this.route,
      queryParams: queryParams,
      queryParamsHandling: 'merge'
    });
  }

}

